import Svg from 'components/utilities/svg'

const DrillIcon = ({ ...props }) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <title>Drill Icon</title>
    <path d="M9.3490563 15.30399811v-2.53063788l5.29976531-1.69651702 1e-8 2.48050936zM9.34905631 11.30399813V8.77336025l5.2997653-1.69651704 1e-8 2.48050936zM13.65463025 1.36378534h-3.30925973c-.54996012.00163615-.99538443.44706045-.99702056.99702056l-1e-8 4.65878018 5.30330086-1.70070071-.02828427-2.98636374c-.0162687-.52813281-.44060348-.95246759-.96873629-.96873629ZM9.34834968 20.05644967l2.65165043 2.65165043 2.65165043-2.65165043.00707102-4.93039533-5.30330081 1.74195285z" />
  </Svg>
)

DrillIcon.displayName = 'Drill'

export default DrillIcon
